/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// important values, prevent typos
export const valuesLib = {
    // tier 1 size
    stems12: 'stems_12',
    stems24: 'stems_24',

    // tier 2 vase
    noVase: 'no_vase',
    wrap: 'wrap',
    clearVase: 'clear_vase',
    clearHourglassVase: 'clear_hourglass_vase',
    pinkHourglassVase: 'pink_hourglass_vase',
    redHourglassVase: 'red_hourglass_vase',
    redFootedVase: 'red_footed_vase',
    purpleVase: 'purple_vase',
    purpleFootedVase: 'purple_footed_vase',
    waterfordVase: 'crystal_vase',

    // tier 3 specialty items
    brownBear: 'brown_bear',
    bear: 'bear',
    candle: 'candle',
    loveBalloon: 'love_balloon',
    newBabyBalloon: 'new_baby_balloon',
    congratsBalloon: 'congrats_balloon',
    thankYouBalloon: 'thank_you_balloon',
    getWellBalloon: 'get_well_balloon',
    birthdayBalloon: 'birthday_balloon',

    // tier 4 sweet treats
    chocolate: 'sending_smiles_chocolate',
    cookie: 'birthday_cookie',
    godivaChocolate: 'godiva_chocolate',

    // tier 5 jewelry
};

export const skuToBasecodeMap = {
    '1001-P-90925': '1001-P-183480',
    '1001-P-91789': '1001-P-183480',
    '1001-P-90926': '1001-P-183481',
    '1001-P-91790': '1001-P-183481',

    // '1001-P-100551': '1001-P-183480',
    // '1001-P-107043': '1001-P-183480',
    // '1001-P-145008': '1001-P-183480',
    // '1001-P-145023': '1001-P-183480',
    // '1001-P-145024': '1001-P-183480',
    // '1001-P-145025': '1001-P-183480',
    // '1001-P-160079': '1001-P-183480',
    // '1001-P-102429': '1001-P-183481',
    // '1001-P-145734': '1001-P-183481',
};

/**
 * @description Returns an alternative basecode based on the one passed in. Returns false if none found.
 * @param {number | string} sku
 * @returns {number | boolean}
 */
export function skuMapsTo(sku) {
    const basecode = skuToBasecodeMap[sku];

    if (basecode) {
        return basecode;
    }

    return false;
}

// temporary
export function isVaseConfigProduct(partNumber) {
    if (partNumber === '1001-P-183481' || partNumber === '1001-P-183480') {
        return true;
    }
    return false;
}
